// Create unique name from default name by adding 1,2,3,4 to
// the default name until solution found
export const createUniqueName = ({ name, existing }: { name: string; existing: string[] }) => {
  if (!existing.find((n) => n == name)) return name;
  let nextIndex = 2;
  let candidateName = nameWithoutPostfix(name);
  while (existing.find((n) => n == candidateName)) {
    candidateName = nameWithoutPostfix(name) + ' ' + nextIndex;
    nextIndex++;
  }
  return candidateName;
};

// Remove uniqueness postfix eg. "MyApp 2" => "MyApp"
export const nameWithoutPostfix = (name: string) => {
  const match = name.match(/^(.+)\s+(\d+)$/);
  return match ? match[1] : name;
};
